
import { Document, Page, Text, View, StyleSheet, Font } from '@react-pdf/renderer';

const StudentListPDF = ({ classData, studentData }) => {
    return (
        <Document>
            <Page size="A4" orientation="landscape" style={styles.page}>
                <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold' }}>Student List</Text>
                <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold' }}>Class: {classData}</Text>
                <Text style={{ fontSize: 11, fontFamily: 'Helvetica-Bold' }}>Tutor:</Text>
                {/* ----- Table Container ----- */}
                <View style={[styles.table, { marginTop: 20 }]}>
                    <View style={[styles.row, styles.bold]}>
                        <Text style={[styles.col1, { borderRight: '1px solid #e0e0e0' }, { borderLeft: '1px solid #e0e0e0' }, { fontFamily: 'Helvetica-Bold' }]}>No</Text>
                        <Text style={[styles.col6, { borderRight: '1px solid #e0e0e0' }, { fontFamily: 'Helvetica-Bold' }]}>Name</Text>
                        <Text style={[styles.col1, { borderRight: '1px solid #e0e0e0' }, { fontFamily: 'Helvetica-Bold' }]}> </Text>
                        <Text style={[styles.col1, { borderRight: '1px solid #e0e0e0' }, { fontFamily: 'Helvetica-Bold' }]}> </Text>
                        <Text style={[styles.col1, { borderRight: '1px solid #e0e0e0' }, { fontFamily: 'Helvetica-Bold' }]}> </Text>
                        <Text style={[styles.col1, { borderRight: '1px solid #e0e0e0' }, { fontFamily: 'Helvetica-Bold' }]}> </Text>
                        <Text style={[styles.col1, { borderRight: '1px solid #e0e0e0' }, { fontFamily: 'Helvetica-Bold' }]}> </Text>
                    </View>
                    {studentData.map((row, i) => (
                        <View key={i} style={[styles.row, i === studentData.length - 1 && { borderBottom: '1px solid #e0e0e0' }]} wrap={false}>
                            <Text style={[styles.col1, { borderRight: '1px solid #e0e0e0' }, { borderLeft: '1px solid #e0e0e0' }]}>{i + 1}</Text>
                            <Text style={[styles.col6, { borderRight: '1px solid #e0e0e0' }]}>{row.fullname ? row.fullname : "-"}</Text>
                            <Text style={[styles.col1, { borderRight: '1px solid #e0e0e0' }]}> </Text>
                            <Text style={[styles.col1, { borderRight: '1px solid #e0e0e0' }]}> </Text>
                            <Text style={[styles.col1, { borderRight: '1px solid #e0e0e0' }]}> </Text>
                            <Text style={[styles.col1, { borderRight: '1px solid #e0e0e0' }]}> </Text>
                            <Text style={[styles.col1, { borderRight: '1px solid #e0e0e0' }]}> </Text>
                        </View>
                    ))}
                </View>
            </Page>
        </Document>

    )
};

export default StudentListPDF;

Font.register({
    family: 'Open Sans',
    fonts: [
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf' },
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600 },
        { src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf', fontWeight: 600, fontStyle: "italic" }
    ]
});

// Create styles
const styles = StyleSheet.create({
    page: {
        backgroundColor: 'white',
        padding: 20
    },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1,
    },
    table: {
        width: '100%'
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        borderTop: '1px solid #e0e0e0'
    },
    bold: {
        fontWeight: 'bold',
    },
    // So Declarative and unDRY 👌
    col1: {
        width: '10%',
        fontSize: 7,
        fontFamily: 'Helvetica',
        padding: 5
    },
    col2: {
        width: '20%',
        fontSize: 7,
        fontFamily: 'Helvetica',
        textAlign: "center",
        padding: 5
    },
    col3: {
        width: '30%',
        fontSize: 7,
        fontFamily: 'Helvetica',
        textAlign: "center",
        padding: 5
    },
    col6: {
        width: '60%',
        fontSize: 7,
        fontFamily: 'Helvetica',
        padding: 5
    }
});